import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { ErrorIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

const ErrorNotifciation = ({ additionalMessage, message, title })=> (
  <Fragment>
    <p><ErrorIcon /> { title }</p>
    <p>{ message }</p>
    { additionalMessage }
  </Fragment>
);

ErrorNotifciation.propTypes = {
  additionalMessage: PropTypes.node,
  message: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired
};

export default ErrorNotifciation;
